module.exports = __webpack_public_path__ + "img/live_faults.ac3ccb75.png";